export var defaultOptions = function () { return ({
    rate: 5,
    size: 16,
    primaryColor: '#FFE135',
    secondColor: '#ddd',
}); };
//# sourceMappingURL=default-options.js.map